var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.theme.components.BaseElementLayout, {
    tag: "component",
    attrs: {
      "el$": _vm.el$
    }
  }, [_c('template', {
    slot: "field"
  }, [_vm._t("prefix"), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-text-field', {
    attrs: {
      "type": "hidden",
      "name": "signature"
    },
    model: {
      value: _vm.signature,
      callback: function callback($$v) {
        _vm.signature = $$v;
      },
      expression: "signature"
    }
  }), _vm.signature ? _c('v-img', {
    staticStyle: {
      "max-width": "80vw"
    },
    attrs: {
      "src": _vm.signature
    }
  }) : _vm._e(), _c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "green",
      "dark": ""
    },
    on: {
      "click": function click($event) {
        return _vm.requestFullscreen();
      }
    },
    slot: "activator"
  }, [_vm._v("\n        Signature\n      ")]), _c('v-bottom-sheet', {
    attrs: {
      "full-width": ""
    },
    model: {
      value: _vm.sheet,
      callback: function callback($$v) {
        _vm.sheet = $$v;
      },
      expression: "sheet"
    }
  }, [_vm.sheet ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-2"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n                "), _c('v-spacer'), _c('v-icon', {
    attrs: {
      "color": "red",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.sheet = false;
      }
    }
  }, [_vm._v("close")])], 1), _c('v-card-text', {
    staticClass: "py-0 my-0"
  }, [this.saving === false ? _c('VueSignaturePad', {
    ref: "signaturePad",
    staticClass: "signaturePad",
    attrs: {
      "height": "60vh",
      "width": "100%"
    }
  }) : _c('v-progress-circular', {
    attrs: {
      "size": 100,
      "width": 10,
      "color": "primary",
      "indeterminate": ""
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "bottom": "",
      "color": "red",
      "dark": "",
      "fab": "",
      "left": ""
    },
    on: {
      "click": _vm.undo
    }
  }, [_c('v-icon', {
    staticClass: "d-flex"
  }, [_vm._v("undo")])], 1), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "bottom": "",
      "color": "green",
      "dark": "",
      "fab": "",
      "right": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', {
    staticClass: "d-flex"
  }, [_vm._v("save")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._t("suffix")], 2), _vm._t("label", null, {
    "slot": "label",
    "el$": _vm.el$
  }), _vm._t("info", null, {
    "slot": "info",
    "el$": _vm.el$
  }), _vm._t("before", null, {
    "slot": "before",
    "el$": _vm.el$
  }), _vm._t("between", null, {
    "slot": "between",
    "el$": _vm.el$
  }), _vm._t("error", null, {
    "slot": "error",
    "el$": _vm.el$
  }), _vm._t("after", null, {
    "slot": "after",
    "el$": _vm.el$
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }